module.exports = __webpack_public_path__ + "img/bio2.b699165a.jpg";